export enum VerificationStatusEnum {
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
  LOCKED_OUT = 'LOCKED_OUT',
  IN_PROGRESS = 'IN_PROGRESS',
}
